<div class="max-w-[1400px]">
    @if (!disabled) {
    <div class="flex justify-end mb-4">
        <sag-ui-input [formControl]="searchControl" placeholder="Search Order Lines..." class="max-w-[300px] w-full"
            ><span
                ngProjectAs="end-decorator"
                class="text-[#B3B3B3] pr-4 h-full flex items-center justify-center icon-search"
            >
            </span
        ></sag-ui-input>
    </div>
    }
    <label class="text-sm text-shs-gray-1"><span>*</span>Select the affected Order Lines</label>
    <div class="mt-2 overflow-x-auto">
        <div class="min-w-[1120px]">
            <div
                class="grid grid-cols-[32px_70px_95px_115px_80px_minmax(160px,1fr)_85px_80px_95px_85px_80px_85px] gap-1 border-b border-shs-gray-4"
            >
                <div class="text-font-tertiary px-1.5 py-2 text-sm truncate flex items-center gap-1">
                    <sag-ui-checkbox
                        [checked]="allItemsSelected()"
                        [intermediate]="someItemsSelected() && !allItemsSelected()"
                        [disabled]="disabled"
                        [ariaLabel]="'Select all items'"
                        (change)="selectAll()"
                    />
                </div>
                <div class="text-font-tertiary px-1.5 py-2 text-sm truncate">Line Item</div>
                <div class="text-font-tertiary px-1.5 py-2 text-sm truncate">SMN</div>
                <div class="text-font-tertiary px-1.5 py-2 text-sm truncate">Delivery Number</div>
                <div class="text-font-tertiary px-1.5 py-2 text-sm truncate">Batch</div>
                <div class="text-font-tertiary px-1.5 py-2 text-sm truncate">Description</div>
                <div class="text-font-tertiary px-1.5 py-2 text-sm truncate text-center">Handling Unit</div>
                <div class="text-font-tertiary px-1.5 py-2 text-sm truncate text-center">Price/Item</div>
                <div class="text-font-tertiary px-1.5 py-2 text-sm truncate text-center">Source Plant</div>
                <div class="text-font-tertiary px-1.5 py-2 text-sm truncate text-center">Source Country</div>
                <div class="text-font-tertiary px-1.5 py-2 text-sm truncate text-center">Sales Order Qty</div>
                <div class="text-font-tertiary px-1.5 py-2 text-sm truncate text-center">Affected Qty</div>
            </div>
            <div class="h-[300px] overflow-y-auto overflow-x-hidden">
                @if (filteredItems.length === 0) {
                <div class="text-font-tertiary p-2 text-sm text-center h-full flex items-center justify-center">
                    No items found
                </div>
                } @for (item of filteredItems; track getItemId(item)) {
                <div
                    class="grid grid-cols-[32px_70px_95px_115px_80px_minmax(160px,1fr)_85px_80px_95px_85px_80px_85px] gap-1 border-b border-shs-gray-4"
                >
                    <div class="text-font-tertiary px-1.5 py-3 flex items-center gap-1">
                        <sag-ui-checkbox
                            [checked]="isChecked(item)"
                            [disabled]="disabled"
                            [ariaLabel]="'Select item ' + item.materialDescription"
                            (change)="toggleItem(item)"
                        />
                    </div>
                    <div
                        class="text-font-tertiary px-1.5 py-3 text-xs"
                        sag-ui-tooltip
                        tooltip="{{ item.salesOrderLine }}"
                    >
                        {{ item.salesOrderLine }}
                    </div>
                    <div class="text-font-tertiary px-1.5 py-3 text-xs" sag-ui-tooltip tooltip="{{ item.smn }}">
                        {{ removeLeadingZeros(item.smn) }}
                    </div>
                    <div
                        class="text-font-tertiary px-1.5 py-3 text-xs"
                        sag-ui-tooltip
                        tooltip="{{ item.deliveryNumber }}"
                    >
                        {{ item.deliveryNumber }}
                    </div>
                    <div class="text-font-tertiary px-1.5 py-3 text-xs" sag-ui-tooltip tooltip="{{ item.batch }}">
                        {{ item.batch }}
                    </div>
                    <div
                        class="text-font-tertiary px-1.5 py-3 text-xs truncate"
                        sag-ui-tooltip
                        tooltip="{{ item.materialDescription }}"
                    >
                        {{ item.materialDescription }}
                    </div>
                    <div
                        class="text-font-tertiary px-1.5 py-3 text-xs truncate text-center"
                        sag-ui-tooltip
                        tooltip="{{ item.handlingUnit }}"
                    >
                        {{ item.handlingUnit }}
                    </div>
                    <div
                        class="text-font-tertiary px-1.5 py-3 text-xs truncate text-center"
                        sag-ui-tooltip
                        tooltip="{{ item.price | currency : currency }}"
                    >
                        {{ item.price | currency : currency }}
                    </div>
                    <div
                        class="text-font-tertiary px-1.5 py-3 text-xs truncate text-center"
                        sag-ui-tooltip
                        tooltip="{{ item.sourcePlant }}"
                    >
                        {{ item.sourcePlant }}
                    </div>
                    <div
                        class="text-font-tertiary px-1.5 py-3 text-base truncate text-center"
                        sag-ui-tooltip
                        tooltip="{{ item.sourceCountry }}"
                    >
                        {{ item.sourceCountry }}
                    </div>
                    <div
                        class="text-font-tertiary px-1.5 py-3 text-base truncate text-center"
                        sag-ui-tooltip
                        tooltip="{{ item.salesOrderQuantity }}"
                    >
                        {{ item.salesOrderQuantity }}
                    </div>
                    <div class="text-font-tertiary px-1.5 py-3 text-xs truncate">
                        @if (isChecked(item)) {
                        <app-number-input
                            [value]="getQuantity(item)"
                            [max]="item.salesOrderQuantity"
                            [readonly]="disabled"
                            [ariaLabel]="item.materialDescription + ' affected quantity'"
                            (valueChange)="setQuantity(item, $event); calcTotalQuantity()"
                        ></app-number-input>
                        }
                    </div>
                </div>
                }
            </div>
        </div>
    </div>
    <div class="grid grid-cols-[1fr_3fr_2fr_5fr_2fr_2fr] gap-2">
        <span class="text-font-tertiary px-2 py-4 text-base font-bold truncate col-span-5 text-right"
            >Overall Affected Quantity</span
        >
        <span class="text-font-tertiary px-2 py-4 text-base truncate"
            ><app-number-input
                [value]="totalQuantity"
                [readonly]="true"
                [ariaLabel]="'Total affected quantity'"
            ></app-number-input
        ></span>
    </div>
</div>
